import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=38ea7c1d&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=38ea7c1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ea7c1d",
  null
  
)

export default component.exports